import { Button, Image, Tab, Tabs } from 'react-bootstrap';
import React, { useEffect, useState } from 'react';

import { useToast } from '../hooks/toast';
import { useAuth } from '../hooks/auth';
import AparenciaIcon from '../assets/icon/aparenciaBranco.svg';
import ClientAreaAparrence from '../components/ClientAreaAparrence';
import ChatAreaAparrence from '../components/ChatAreaAparrence';
import ClientLogo from '../components/ClientLogo';

import IParametroAparencia from '../interfaces/IParametroAparencia';

import api from '../services/apiClient';

const ConfigAppearance: React.FC = () => {
  const [key, setKey] = useState('areaCliente');
  const [corPrincial, setCorPrincial] = useState('#616161');
  const [corFundo, setCorFundo] = useState('#616161');
  const [imagemFundo, setImagemFundo] = useState('');
  const [corFundoChat, setCorFundoChat] = useState('#616161');
  const [imagemFundoChat, setImagemFundoChat] = useState('');
  const [corTextoOperador, setCorTextoOperador] = useState('#FFFFFF');
  const [corTextoCliente, setCorTextoCliente] = useState('#FFFFFF');
  const [corCaixaTextoOperador, setCorCaixaTextoOperador] = useState('#008BEF');
  const [corCaixaTextoCliente, setCorCaixaTextoCliente] = useState('#FFC107');
  const [corNomeOperadorCliente, setCorNomeOperadorCliente] =
    useState('#FFC107');
  const [corTitulo, setCorTitulo] = useState('#FFC107');
  const [opacidadeImagem, setOpacidadeImagem] = useState(0);
  const [imgFileLogoEmpresa, setImgFileLogoEmpresa] = useState<File | null>(
    null
  );
  const [imgFileLogoCliente, setImgFileLogoCliente] = useState<File | null>(
    null
  );

  const { addToast } = useToast();

  useEffect(() => {
    const token = localStorage.getItem('@LiveChat:token');

    api
      .get('/Parametro/ParametroAparencia/CSOFTWARE', {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data;
        if (result.success) {
          setCorPrincial(result.data.corPrincipal);
          setCorFundo(result.data.corPlanoFundoPrincipal);
          setImagemFundo(result.data.planoFundoPrincipal);
          setCorFundoChat(result.data.corPlanoFundoPrincipalChat);
          setImagemFundoChat(result.data.planoFundoPrincipalChat);
          setCorTextoOperador(result.data.corTextoOperador);
          setCorTextoCliente(result.data.corTextoCliente);
          setCorCaixaTextoOperador(result.data.corCaixaTextoOperador);
          setCorCaixaTextoCliente(result.data.corCaixaTextoCliente);
          setCorTitulo(result.data.corTitulo);
          setCorNomeOperadorCliente(result.data.corNomeOperadorCliente);
          setOpacidadeImagem(result.data.opacidadeImagem);
        } else {
          addToast({ title: result.message, type: 'error' });
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  }, []);

  const handleConfirmar = (): void => {
    const token = localStorage.getItem('@LiveChat:token');

    const data: IParametroAparencia = {
      corPrincipal: corPrincial,
      corPlanoFundoPrincipal: corFundo,
      planoFundoPrincipal: imagemFundo,
      corPlanoFundoPrincipalChat: corFundoChat,
      planoFundoPrincipalChat: imagemFundoChat,
      corTextoOperador,
      corCaixaTextoOperador,
      corTextoCliente,
      corCaixaTextoCliente,
      corNomeOperadorCliente,
      corTitulo,
      opacidadeImagem,
    };

    api
      .post('/Parametro/ParametroAparencia', data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data;
        if (result.success) {
          if (imgFileLogoEmpresa || imgFileLogoCliente) {
            const formData = new FormData();

            if (imgFileLogoEmpresa)
              formData.append('logoSuporte', imgFileLogoEmpresa);

            if (imgFileLogoCliente)
              formData.append('logoCliente', imgFileLogoCliente);

            api.post('/Parametro/ParametroAparencia/Logo', formData, {
              headers: { Authorization: `Bearer ${token}` },
            });
          }

          addToast({
            type: 'success',
            title: 'Sucesso',
            description: 'Dados gravados com sucesso',
          });
        } else {
          addToast({ title: result.message, type: 'error' });
        }
      })
      .catch((error) => {
        console.log('error', error);
      });
  };

  return (
    <div>
      <div
        className="w-100 d-flex align-items-center ps-3"
        style={{
          backgroundColor: '#1A1A1A',
        }}
      >
        <Image
          src={AparenciaIcon}
          style={{ width: '1.6rem', height: '1.6rem' }}
          alt="Configurações"
        />
        <span
          className="text-white ms-2"
          style={{
            fontSize: '1.68rem',
            fontWeight: '600',
            backgroundColor: '#1A1A1A',
          }}
        >
          Aparência
        </span>
      </div>
      <div
        className=" mt-2 mx-2 overflow-auto"
        style={{
          borderRadius: '0.68rem',
          height: 'Calc(100vh - 22.5rem)',

          boxShadow: '0px 4px 6px 3px rgba(0, 0, 0, 0.25)',
        }}
      >
        <Tabs
          id="tabGroupUserConfig"
          activeKey={key}
          className="mb-2"
          onSelect={(k) => setKey(String(k))}
          style={{ fontSize: '1.25rem', fontWeight: '600' }}
        >
          <Tab eventKey="areaCliente" title="Área do Cliente" className="mb-2">
            <ClientAreaAparrence
              corPrincial={corPrincial}
              setCorPrincial={setCorPrincial}
              corFundo={corFundo}
              setCorFundo={setCorFundo}
              imagemFundo={imagemFundo}
              setImagemFundo={setImagemFundo}
            />
          </Tab>

          <Tab eventKey="chat" title="Chat">
            <ChatAreaAparrence
              corPrincial={corPrincial}
              setCorPrincial={setCorPrincial}
              corFundo={corFundoChat}
              setCorFundo={setCorFundoChat}
              imagemFundo={imagemFundoChat}
              setImagemFundo={setImagemFundoChat}
              corTextoOperador={corTextoOperador}
              setCorTextoOperador={setCorTextoOperador}
              corTextoCliente={corTextoCliente}
              setCorTextoCliente={setCorTextoCliente}
              corCaixaOperador={corCaixaTextoOperador}
              setCorCaixaOperador={setCorCaixaTextoOperador}
              corCaixaCliente={corCaixaTextoCliente}
              setCorCaixaCliente={setCorCaixaTextoCliente}
              corNomeOperadorCliente={corNomeOperadorCliente}
              setCorNomeOperadorCliente={setCorNomeOperadorCliente}
              corTitulo={corTitulo}
              setCorTitulo={setCorTitulo}
              opacidadeImagem={opacidadeImagem}
              setOpacidadeImagem={setOpacidadeImagem}
            />
          </Tab>

          <Tab eventKey="logo" title="Logo">
            <ClientLogo
              imgFileLogoEmpresa={imgFileLogoEmpresa}
              setImgFileLogoEmpresa={setImgFileLogoEmpresa}
              imgFileLogoCliente={imgFileLogoCliente}
              setImgFileLogoCliente={setImgFileLogoCliente}
            />
          </Tab>
        </Tabs>
      </div>
      <div className="d-flex justify-content-center align-items-center">
        <Button
          variant="secondary"
          type="button"
          className="mt-2 me-1"
          style={{ fontSize: '1.25rem', fontWeight: '600' }}
        >
          limpar dados
        </Button>
        <Button
          variant="primary"
          type="submit"
          className="mt-2 ms-1"
          onClick={() => handleConfirmar()}
          style={{ fontSize: '1.25rem', fontWeight: '600' }}
        >
          confirmar
        </Button>
      </div>
    </div>
  );
};

export default ConfigAppearance;
